import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import SVGInline from 'react-svg-inline';

import IconButton from 'legacy/components/generic/IconButton';
import Popover from 'legacy/components/generic/Popover';
import SimpleLoader from 'legacy/components/generic/SimpleLoader';

import { getIsEffectiveDateReport } from 'selectors/property-explorer';
import downloadIcon from 'legacy/assets/svg-inline/download.svg';

import { DownloadReportButton as theme } from 'legacy/css-modules';

const DownloadReportButton = ({
  isDownloadingXLS,
  isDownloadingPDF,
  disableControls,
  handleClickExcel,
  handleClickPdf,
  handleClickPrint,
  locationUnknown,
  isExcelDownloadAllowed
}) => {
  const isEffectiveDateReport = useSelector(getIsEffectiveDateReport);
  if (isEffectiveDateReport) return null;
  const downloadOptions = [
    {
      label: 'PDF',
      dataHcName: 'download-pdf-option',
      onClick: handleClickPdf
    }
  ];
  if (isExcelDownloadAllowed) {
    downloadOptions.push({
      label: 'Excel',
      dataHcName: 'download-excel-option',
      onClick: handleClickExcel
    });
  }
  return (
    <div className="share-report-buttons--download-button">
      <Popover
        closeOnChildClick
        Button={
          <IconButton
            id="download-report-button"
            dataHcName="download-report-button"
            disabled={
              disableControls ||
              isDownloadingPDF ||
              isDownloadingXLS ||
              locationUnknown
            }
            label={'Download'}
            icon={
              isDownloadingXLS || isDownloadingPDF ? (
                <SimpleLoader />
              ) : (
                <SVGInline
                  className={theme.DownloadIcon}
                  height="30px"
                  width="30px"
                  svg={downloadIcon}
                />
              )
            }
          />
        }
        minWidth="100px"
        menuItems={downloadOptions}
      />
    </div>
  );
};

DownloadReportButton.propTypes = {
  handleClickExcel: PropTypes.func.isRequired,
  handleClickPdf: PropTypes.func.isRequired,
  uniqueLinkDoesNotExist: PropTypes.bool,
  isLoadingShare: PropTypes.bool,
  isDownloadingXLS: PropTypes.bool,
  isDownloadingPDF: PropTypes.bool
};

export default DownloadReportButton;
